import i18n from 'assets/i18n'
import { UserSettings } from 'oidc-client'
import { Country } from 'screens/accounts/stores/types'
import { RolePrivilege } from 'screens/context/stores/types'
import { actionCreators } from 'screens/login/stores/actions'
import { RpUser } from 'screens/login/stores/types'
import store from "stores/store"
import { IAlertType } from '../components/RPAlert/stores/types'
import { pkceLogin, pkceRenewToken } from '../services/authentication/PkceOidcAuthentication'
import { SortDirection } from './types'
import moment from "moment"

export const useDefaultUser: boolean | undefined = process.env.REACT_APP_USE_DEFAULT_USER === "true";

export const defaultUser: UserSettings = ({
  id_token: "",
  session_state: "",
  access_token: "eyJraWQiOiIxNzY3IiwidHlwIjoiSldUIiwiYWxnIjoiUlMyNTYifQ.eyJpc3MiOiJodHRwczovL2lkcDIucmVuYXVsdC5jb20vbmlkcC9vYXV0aC9uYW0iLCJqdGkiOiI5NDU4MThlOS1kMTZjLTRhZDAtOTZhZC0wZmZmMzczOTFhNDkiLCJhdWQiOiJkODdhN2E1YS0wMmNhLTQxMTgtODQ0NS0wNWFmMzVjM2I1MTUiLCJleHAiOjE2NDg3NDEwMTUsImlhdCI6MTY0ODczOTIxNSwibmJmIjoxNjQ4NzM5MTg1LCJzdWIiOiIzNTY2MzQ2MTM2MzczODMxMmQzMDY1NjYzOTMxMzE2NTYzMmQzODM1MzAzMjM5NjQzOTM0MmQ2MjMzMzczNzM3NjMzODY2IiwiX3B2dCI6IjBzajY3dEZEWGF2Q3dpb1lKQVNjYXk2K3JBRFBQclc1Q2FvS0djRDNNQmhCRHVIZkJNQkpxQ0Fma1pkU2V0ZVlKdmpudVpFNGZiV2RNQkppSWVYZWpadGRhMlpVUVlnd3VjYlUyWjkrSHV3UFlpZmZEc1U4TWUyclhLSmxxZzE2dWFWbjM2a21KOVQ2N0RuZlZTU0pwZkFxbXBLMjBBSDh4SnpXaS9ZbEdKVDRnYzVMNG9mRmlSckM2Vllhd2NYUHpKTVRsVUZOMWVkQjVHREpMbFphSVpHQWEzR0swOVR0Y29XdUtsOVhMczU5azRia3hUNHQ0MmgrWGdaR3g2c1dxUEJrREZIN1FJdkVOZDdXR1VBeTk0ajRoREM3TTV5SENOSFYvTGZJUVBRTUZvOVA0QmFvUiszSXRrZWpEOWxOcHhwY05vc0tsVlBsVitpV042Vi9YbGNKazdMMTlBMmd2UXh1ZmFUV3NLaFlSSXlna0VhY1g1VEtFdmNkdnBuWGplZHMrWmdQRUxCaVR3SjdQYWEvRy9QOHpQS0JqUEFoZjVnc29MME16UzhKYU4xVzA0ZGdXMFVTTGNnckJhalNReXBwVUFwT0ZxQ2Iwd1ZBc0YzVENEL282eHFreVgyRlZoQStqcndOTm0xM2ZnNms3cTZOMSt6UEkvdkczY1NUNzNtNkFkQ29YamU3VjhrWXRwUGEwTUNjODJkTTY3K3dQYlI1NkFJdjhjTTBnSXJ2V1pWcWF0azVWcnVzM3hGbVdUM2FtOFpiNlBvTjQ0Mk96RVpadEFoSEdreFFDZWNjeCszVXJ4Z1k5UXJFUXhHTVZlUU5ReWROdlU3dkp0akQuNSIsInNjb3BlIjpbInJvbGUtcm5ldC1ycHMtaXJuNjk0MyIsImFyY2EiLCJyb2xlLXJwcy1pcm42OTQzIiwicm9sZS0xcG8taXJuNzI3OTUiLCJyb2xlLXJuZXQtMXBvLWlybjcyNzk1IiwidmVjdHVyeS11c2VyIiwidmVjdHVyeSIsImVtYWlsIl0sInVpZCI6InAxMTIwNTIiLCJmaXJzdG5hbWUiOiJKZXJvbWUiLCJ1c2VyRGlyZWN0b3J5IjoiYXJjYSIsInBvc3RPZmZpY2VCb3giOiJGUkVRVk5PVjA4NSIsInByZWZlcnJlZExhbmd1YWdlIjoiRlIiLCJtYWlsIjoiamVyb21lLmNlbGViaS1leHRlcm5AcmVuYXVsdC5jb20iLCJjb3N0Q2VudGVyIjoiQUE1MDE1NSIsInJvbGUtcnBzLWlybjY5NDMiOiJbcnBzLXB1YmxpY2F0aW9uLWZpbGlhbGUtZnIsIGFkbWluY2F0YWxvZy1hZG1pbmNhdCwgYWRtaW5jYXRhbG9nLWFkbWlucGFyYW0sIGFkbWluY2F0YWxvZy1hZG1pbndjY10iLCJyb2xlLTFwby1pcm43Mjc5NSI6IjFwby1jb3VudHJ5LWFkbWluIiwiY29tcGFueSI6ImNvbWV0IiwicGVyc29uVHlwZSI6ImNhdHByZ3IiLCJsYXN0bmFtZSI6IkNlbGViaSIsIl90YXJnZXQiOiJJZGVudGl0eVByb3ZpZGVyIn0.UdeKdfEaqojajGDejjyiBBjOaqIQsNIRZvo90wpym3P7jn6jdzZOFy_ovze-u8D1HaEdCeAYlzVuYKYpR7rKIKru0-GMq-aBuATo5rn3jFBqXKRkUsDWi4rDBxZ11_48PVBHmoEBOnktTFELuldSeyiGXw0XoYTTO7FIxPHqvvVPjI_nhZQGsi2t-ecGyM3xkTuLM3HUZNEd_1Tob_wWE2EOnlfChxVS84tS1YJxqOm1DksHuFHlGc3hpQmj0RDYYZ_zbjNtgw1nn84YXk1ZCs6xXZCSuR7RBwH-xnvJK4MzAU6wPZF4ICBfuV3kaw4w-a-n_WfXQbN6ez3bCtwvlQ",
  token_type: "",
  state: "",
  expires_at: 1646140115,
  refresh_token: "",
  "scope": [
    "role-rnet-rps-irn6943",
    "arca",
    "role-rps-irn6943",
    "role-1po-irn72795",
    "vectury-user",
    "vectury",
    "email"
  ].join(","),
  profile: {
    "iss": "",
    "jti": "",
    "aud": "",
    "exp": 1647140115,
    "iat": 1646132915,
    "nbf": 1646132885,
    "sub": "",
    "_pvt": "",
    "firstname": "JOHN",
    "preferredLanguage": "FR",
    "mail": "renault.test@renault.com",
    "entity_name": "GARAGE",
    "address_country": "FR",
    "entity_tradename": "GARAGE",
    // "entity_identifiers": ["VECTURY;OU;00015021", "BIR;LocationId;00015021"],
    "entity_identifiers": ["VECTURY;OU;00900001", "BIR;LocationId;00900001"],
    "locale": "fr_FR",
    "given_name": "JOHN",
    // "person_identifiers": ["VECTURY;UID;p000000", "BIR;PersonId;0000000000000"],
    "lastname": "DOE",
    // "role-rnet-rps-irn6943": ["IRN-6943:commandes", "IRN-6943:commandemultimarques", "IRN-6943:consultation", "IRN-6943:adhesion"],
    // "role-1po-irn72795": ["1po-central-admin"],
    // "role-1po-irn72795": ["1po-country-admin"],
    // "role-1po-irn72795": ["1po-country-subscription"],
    "role-1po-irn72795": ["1po-r1"],
    "uid": "p000000",
    "userDirectory": "vectury",
    "phone": "",
    "name": "John DOE",
    "entity_shortname": "RENAULT_JD_GARAGE",
    "family_name": "DOE",
    "email": "john.doe@renault.com",
    "_target": "IdentityProvider"
  }
});

export const delay = (ms: number) => new Promise(res => setTimeout(res, ms))

// Alert for dev purposes
export const createGenericErrorAlert = (error: any): IAlertType => {
  return {
    ...error,
    code: error.response?.status || error.message?.status,
    message: error.response?.statusText || error.message?.statusText,
    description: error.response?.request.responseURL || error.message?.request?.responseURL,
    type: 'error'
  }
}

export const createErrorMsg = (description: string): IAlertType => {
  return {
    message: i18n.t('Generic.Status.ERROR'),
    description,
    displayed: false,
    type: 'error'
  }
}

export const createSuccessMsg = (description: string): IAlertType => {
  return {
    message: i18n.t('Generic.Alert.Done'),
    description,
    displayed: false,
    type: 'success'
  }
}

export const getBirCode = (): string | undefined => {
  const userRolePrivilege = store.getState().rp4.roles.roleData.myRolePrivilege;
  let user: RpUser | undefined = store.getState().rp4.login.user
  let bircode = store.getState().rp4.roles.myBIRCodeData?.bircode
  if (userRolePrivilege === RolePrivilege.R1) bircode = user?.bircode
  return bircode
}

export const getSelectedCountry = (): Country | undefined => {
  const countries = store.getState().rp4.accounts.countries.data;
  const bircode = getBirCode();
  let selectedCountry;
  if (bircode && countries) {
    selectedCountry = countries.filter(country =>
      country.bircodeDataList.filter(
        bircodeData => bircodeData.bircode === bircode
      ).length > 0
    )[0]
  }
  return selectedCountry
}

export const handleTableChange = (payload: any, setPayload: any, columns: any = undefined, setColumns: any = undefined) => {
  return (pagination: any, filters: any, sorter: any) => {
    let newPayload: any = {
      ...payload,
      page: pagination.current - 1,
      size: pagination.pageSize,
    }

    if (typeof sorter?.order !== 'undefined') {
      const sortDirection = SortDirection[sorter.order as keyof typeof SortDirection]
      const sortField = sorter.columnKey;
      const sort = `${sortField},${sortDirection}`

      newPayload = {
        ...newPayload,
        sort,
      }

    } else {
      delete newPayload.name;
      delete newPayload.sort;
      delete newPayload["name.dir"]
    }

    Object.keys(filters).forEach((value: string) => {
      if (!filters[value]) {
        delete newPayload[value]
      } else {
        const filterKey = filters[value]

        newPayload = {
          ...newPayload,
          [value]: value === "fileCreatedDate" ? moment(filterKey[0]).format("MM/DD/YYYY HH:mm:ss") : filterKey[0]
        }
      }
    })
    setPayload(newPayload)

    // Columns
    if (columns && setColumns) {
      const newColumns = columns.map((column: any) => {
        let curColumn = { ...column }

        delete curColumn.filteredValue
        if (curColumn.key in newPayload && curColumn.key in filters) {
          // Filters
          curColumn.filteredValue = filters[curColumn.key]
        }

        delete curColumn.sortOrder
        if (newPayload.sort) {
          // Sorting
          const sort = newPayload.sort.split(",")
          const sortKey = sort[0]
          const sortValue = sort[1]
          if (sortKey === curColumn.dataIndex) {
            curColumn.sortOrder = sortValue === "asc" ? 'ascend' : 'descend'
          }
        }
        return curColumn
      })
      setColumns(newColumns)
    }
  }
}

export async function getRefreshedUser() {
  await pkceRenewToken()
    .then((user: RpUser) => {
      store.dispatch(actionCreators.authLoginSuccess(
        useDefaultUser ? new RpUser(
          { ...defaultUser, access_token: user.access_token }) : user))
    })
    .catch((err: any) => {
      getLoginUser()
    })
}

export async function getLoginUser() {
  await pkceLogin()
    .then((user: RpUser) => {
      store.dispatch(actionCreators.authLoginSuccess(
        useDefaultUser ? new RpUser(
          { ...defaultUser, access_token: user.access_token }) : user))
    })
    .catch((err: any) => {
      console.log("ERROR", err)
    })
}

export function getUserFromLocalStorage(): RpUser | undefined {
  const currentLocalStorageKeys = Object.keys(localStorage).filter(elem => elem.includes("oidc.user"));
  if (currentLocalStorageKeys.length > 0) {
    let user: RpUser = new RpUser({
      ...JSON.parse(localStorage.getItem(currentLocalStorageKeys[0])!)
    });

    if (!user) return undefined
    return useDefaultUser ? new RpUser(defaultUser) : user
  }
}

export const getArgs = (payload: any): string => {
  Object.keys(payload).forEach(x => {
    const value = payload[x];
    if (x === "fileCreatedDate") {
      // const moment1 = moment(value).format("L LTS")
      const moment2 = moment(value).format("YYYY/MM/DD HH:mm:ss")
      payload[x] = moment2
    }
  })
  return new URLSearchParams(payload).toString()
}